import type { Amount, CurrencyCode } from '@tectonics/prs/money';
import type { CheckoutReceipts, Instalments, Receipt } from '../types';

export type InstalmentOptions = {
  readonly amountLocalTotal?: string;
  readonly partialAmount?: string;
};

export const amount = (currency: CurrencyCode, value: string): Amount => [
  currency,
  value,
];

export const createReceipt = (overrides: Partial<Receipt> = {}): Receipt => ({
  fx: {
    from: 'USD',
    to: 'BRL',
    rate: '4.1700',
  },
  amount_ext: amount('USD', '100.00'),
  amount_local_base: amount('BRL', '417.00'),
  amount_local_total: amount('BRL', '418.58'),
  local_taxes: [
    {
      code: 'BR_IOF',
      amount: amount('BRL', '1.58'),
      rate: '0.0038',
    },
  ],
  ...overrides,
});

export const createInstalmentReceipt = (
  instalments: number,
  options: InstalmentOptions = {},
): Receipt => {
  const amountLocalTotal = options.amountLocalTotal ?? '418.58';
  const partialAmount = options.partialAmount ?? amountLocalTotal;

  return createReceipt({
    amount_local_total: amount('BRL', amountLocalTotal),
    instalments_plan: {
      instalments,
      amount_partial_first: amount('BRL', partialAmount),
      amount_partial_other: amount('BRL', partialAmount),
    },
  });
};

export const createCheckoutReceipts = (
  instalments: Instalments,
): CheckoutReceipts => ({
  main: createReceipt(),
  instalments_strategy: 'from-invoice',
  instalments,
});
